import { Route } from '@angular/router';
import {
  ROUTE_AGENT_SELECTION,
  ROUTE_COMPANY_CHECK,
  ROUTE_COMPANY_SELECT,
  ROUTE_CUSTOMER_REGISTRATION,
  ROUTE_HOME,
  ROUTE_INVITE,
  ROUTE_KUNDENACCOUNT_ANPASSEN,
  ROUTE_LOGOUT_SUCCESS,
  ROUTE_THANK_YOU,
} from './app.constants';
import { FrontpageComponent } from './pages/frontpage/frontpage.component';
import { authGuard } from '@shared-ikp/auth/guard/auth.guard';
import { beraterGuard } from './guards/berater.guard';
import { featureFlagGuard } from './guards/feature-flag.guard';
import { FeatureFlag } from './model/feature-flag.model';
import { RegistrationComponent } from './pages/registration/registration.component';
import { CompanySelectComponent } from './pages/registration/01_company_select/company_select.component';
import { CompanyCheckComponent } from './pages/registration/02_company_check/company_check.component';
import { AgentSelectionComponent } from './pages/registration/03_agent_selection/agent_selection.component';
import { InviteComponent } from './pages/registration/04_invite/invite.component';
import { ThankyouComponent } from './pages/registration/05_thank_you/thankyou.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: FrontpageComponent,
    children: [],
  },
  {
    path: ROUTE_LOGOUT_SUCCESS,
    component: FrontpageComponent,
  },
  {
    path: ROUTE_HOME,
    loadChildren: () => import('./pages/main/main.routes').then(mod => mod.MAIN_ROUTES),
    canActivate: [authGuard, beraterGuard],
  },
  {
    path: ROUTE_CUSTOMER_REGISTRATION,
    data: {
      hideHeader: true,
      hideFooter: true,
      toggles: [],
      pageTitle: 'Registration',
    },
    component: RegistrationComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ROUTE_COMPANY_SELECT,
      },
      {
        path: ROUTE_COMPANY_SELECT,
        pathMatch: 'full',
        component: CompanySelectComponent,
      },
      {
        path: ROUTE_COMPANY_SELECT + '/:companyId',
        pathMatch: 'full',
        component: CompanySelectComponent,
      },
      {
        path: ROUTE_COMPANY_CHECK,
        component: CompanyCheckComponent,
      },
      {
        path: ROUTE_AGENT_SELECTION,
        component: AgentSelectionComponent,
      },
      {
        path: ROUTE_INVITE,
        component: InviteComponent,
      },
      {
        path: ROUTE_THANK_YOU,
        component: ThankyouComponent,
      },
    ],
    canActivate: [authGuard, beraterGuard],
  },
  {
    path: ROUTE_KUNDENACCOUNT_ANPASSEN,
    canActivate: [featureFlagGuard(FeatureFlag.KUNDENACCOUNT_ANPASSEN_ENABLED)],
    loadChildren: () =>
      import('./pages/kundenaccount-anpassen/kundenaccount-anpassen.wizard').then(mod => mod.KundenaccountAnpassenWizardModule),
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () => import('./pages/main/main.routes').then(mod => mod.MAIN_ROUTES.find(route => route.path === '').component),
  },
];
